import { atom } from 'jotai';
export const mediaUrlAtom = atom<string | undefined>(undefined);